import { render } from "./EditDashboardRowForOrganisation.vue?vue&type=template&id=61a1d222"
import script from "./EditDashboardRowForOrganisation.vue?vue&type=script&lang=js"
export * from "./EditDashboardRowForOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__